<template>
  <header class="top-nav">
    <!-- 左侧 Logo -->
    <div class="nav-left">
      <img
        class="logo-img"
        src="@/assets/images/logo.png"
        alt="HBH Logo"
      />
      <!-- 移动端汉堡菜单按钮 -->
      <button
        class="mobile-menu-btn"
        @click="toggleMobileMenu"
        aria-label="打开导航菜单"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>
    <!-- 中间导航菜单 -->
    <nav
      :class="[
        'nav-center',
        {
          'mobile-open': mobileOpen
        }
      ]"
    >
      <!-- 首页 -->
      <router-link
        to="/"
        class="nav-item"
        active-class="active"
        exact
      >
        首页
      </router-link>
      <!-- ==================== 概况介绍 ==================== -->
      <div
        class="nav-item dropdown"
        :class="{
          open: openDropdown === 'about'
        }"
        @mouseenter="desktopHover('about')"
        @mouseleave="desktopHover(null)"
      >
        <span
          class="dropdown-title"
          @click="toggleDropdown('about')"
        >
          <router-link
            to="/about"
            class="nav-item dropdown-link"
          >
            概况介绍
          </router-link>
          <span
            class="arrow"
            :class="{
              rotate: openDropdown === 'about'
            }"
          >
            ▼
          </span>
        </span>
        <div class="dropdown-menu">
          <router-link
            to="/about"
            class="dropdown-item"
            @click="closeMobileMenu"
          >
            实验室介绍
          </router-link>
          <router-link
            to="/about/structure"
            class="dropdown-item"
            @click="closeMobileMenu"
          >
            组织架构
          </router-link>
          <router-link
            to="/about/leader"
            class="dropdown-item"
            @click="closeMobileMenu"
          >
            现任领导
          </router-link>
          <router-link
            to="/about/campus"
            class="dropdown-item"
            @click="closeMobileMenu"
          >
            园区风貌
          </router-link>
          <router-link
            to="/about/video"
            class="dropdown-item"
            @click="closeMobileMenu"
          >
            Video介绍
          </router-link>
          <router-link
            to="/about/contact"
            class="dropdown-item"
            @click="closeMobileMenu"
          >
            联系我们
          </router-link>
        </div>
      </div>
      <!-- ==================== 研究系统 ==================== -->
      <div
        class="nav-item dropdown"
        :class="{
          open: openDropdown === 'research'
        }"
        @mouseenter="desktopHover('research')"
        @mouseleave="desktopHover(null)"
      >
        <span
          class="dropdown-title"
          @click="toggleDropdown('research')"
        >
          <router-link
            to="/research"
            class="nav-item dropdown-link"
          >
            研究系统
          </router-link>
          <span
            class="arrow"
            :class="{
              rotate: openDropdown === 'research'
            }"
          >
            ▼
          </span>
        </span>
        <div class="dropdown-menu">
          <router-link
            to="/research/platform"
            class="dropdown-item"
            @click="closeMobileMenu"
          >
            公共研发平台
          </router-link>
          <router-link
            to="/research/center"
            class="dropdown-item"
            @click="closeMobileMenu"
          >
            研究中心
          </router-link>
          <router-link
            to="/research/joint"
            class="dropdown-item"
            @click="closeMobileMenu"
          >
            联合研发中心
          </router-link>
          <router-link
            to="/research/service"
            class="dropdown-item"
            @click="closeMobileMenu"
          >
            公共测试服务平台
          </router-link>
        </div>
      </div>
      <!-- ==================== 应用领域 ==================== -->
      <div
        class="nav-item dropdown"
        :class="{
          open: openDropdown === 'application'
        }"
        @mouseenter="desktopHover('application')"
        @mouseleave="desktopHover(null)"
      >
        <span
          class="dropdown-title"
          @click="toggleDropdown('application')"
        >
          <router-link
            to="/application/materials"
            class="nav-item dropdown-link"
          >
            应用领域
          </router-link>
          <span
            class="arrow"
            :class="{
              rotate:
                openDropdown === 'application'
            }"
          >
            ▼
          </span>
        </span>
        <div class="dropdown-menu">
          <router-link
            to="/application/materials"
            class="dropdown-item"
            @click="closeMobileMenu"
          >
            先进材料
          </router-link>
          <router-link
            to="/application/manufacturing"
            class="dropdown-item"
            @click="closeMobileMenu"
          >
            绿色制造
          </router-link>
        </div>
      </div>
      <!-- ==================== 新闻资讯 ==================== -->
      <div
        class="nav-item dropdown"
        :class="{
          open: openDropdown === 'news'
        }"
        @mouseenter="desktopHover('news')"
        @mouseleave="desktopHover(null)"
      >
        <span
          class="dropdown-title"
          @click="toggleDropdown('news')"
        >
          <router-link
            to="/news/general"
            class="nav-item dropdown-link"
          >
            新闻资讯
          </router-link>
          <span
            class="arrow"
            :class="{
              rotate:
                openDropdown === 'news'
            }"
          >
            ▼
          </span>
        </span>
        <div class="dropdown-menu">
          <router-link
            to="/news/general"
            class="dropdown-item"
            @click="closeMobileMenu"
          >
            综合新闻
          </router-link>
          <router-link
            to="/news/cooperation"
            class="dropdown-item"
            @click="closeMobileMenu"
          >
            合作交流
          </router-link>
          <router-link
            to="/news/science"
            class="dropdown-item"
            @click="closeMobileMenu"
          >
            科普动态
          </router-link>
          <router-link
            to="/news/party"
            class="dropdown-item"
            @click="closeMobileMenu"
          >
            党群文化
          </router-link>
        </div>
      </div>
      <!-- ==================== 通知公告 ==================== -->
      <div
        class="nav-item dropdown"
        :class="{
          open:
            openDropdown === 'announcement'
        }"
        @mouseenter="desktopHover('announcement')"
        @mouseleave="desktopHover(null)"
      >
        <span
          class="dropdown-title"
          @click="toggleDropdown('announcement')"
        >
          <router-link
            to="/announcement/notice"
            class="nav-item dropdown-link"
          >
            通知公告
          </router-link>
          <span
            class="arrow"
            :class="{
              rotate:
                openDropdown === 'announcement'
            }"
          >
            ▼
          </span>
        </span>
        <div class="dropdown-menu">
          <router-link
            to="/announcement/open-topic"
            class="dropdown-item"
            @click="closeMobileMenu"
          >
            开放课题
          </router-link>
          <router-link
            to="/announcement/notice"
            class="dropdown-item"
            @click="closeMobileMenu"
          >
            通知公告
          </router-link>
        </div>
      </div>
      <!-- ==================== 人才招聘 ==================== -->
      <router-link
        to="/offers"
        class="nav-item"
        active-class="active"
        @click="closeMobileMenu"
      >
        人才招聘
      </router-link>
      <!-- ==================== 联系我们 ==================== -->
      <router-link
        to="/about/contact"
        class="nav-item"
        active-class="active"
        @click="closeMobileMenu"
      >
        联系我们
      </router-link>
      <!-- ==================== 新闻搜索 ==================== -->
      <div class="news-search">
        <div class="search-box">
          <!-- 搜索图标 -->
          <span class="search-icon">
            <svg
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path
                d="M10.8 4a6.8 6.8 0 1 0 4.23 12.12l4.43 4.43
                   1.41-1.41-4.43-4.43A6.8 6.8 0 0 0 10.8 4Zm0
                   2a4.8 4.8 0 1 1 0 9.6 4.8 4.8 0 0 1 0-9.6Z"
              />
            </svg>
          </span>
          <!-- 搜索输入框 -->
          <input
            v-model="searchKeyword"
            type="text"
            placeholder="搜索新闻..."
            maxlength="50"
            @keyup.enter="searchNews"
          />
          <!-- 清空按钮 -->
          <button
            v-if="searchKeyword"
            class="search-clear"
            type="button"
            aria-label="清空搜索"
            @click="clearSearch"
          >
            ×
          </button>
          <!-- 搜索按钮 -->
          <button
            class="search-button"
            type="button"
            @click="searchNews"
          >
            搜索
          </button>
        </div>
      </div>
    </nav>
  </header>
</template>
<script>
export default {
  name: 'TopNav',
  data() {
    return {
      /**
       * 移动端菜单
       */
      mobileOpen: false,
      /**
       * 当前打开的下拉菜单
       */
      openDropdown: null,
      /**
       * 新闻搜索关键词
       */
      searchKeyword: ''
    };
  },
  /**
   * ============================================================
   * 监听路由中的 keyword
   *
   * 当：
   *
   * /newsearch?keyword=人工智能
   *
   * 时，顶部搜索框自动显示：
   *
   * 人工智能
   * ============================================================
   */
  watch: {
    '$route.query.keyword': {
      immediate: true,
      handler(newKeyword) {
        this.searchKeyword =
          newKeyword
            ? String(newKeyword)
            : '';
      }
    }
  },
  methods: {
    /**
     * ============================================================
     * 移动端菜单
     * ============================================================
     */
    toggleMobileMenu() {
      this.mobileOpen =
        !this.mobileOpen;
      if (!this.mobileOpen) {
        this.openDropdown = null;
      }
    },
    /**
     * ============================================================
     * 关闭移动端菜单
     * ============================================================
     */
    closeMobileMenu() {
      if (window.innerWidth < 768) {
        this.mobileOpen = false;
        this.openDropdown = null;
      }
    },
    /**
     * ============================================================
     * 移动端点击下拉菜单
     * ============================================================
     */
    toggleDropdown(name) {
      if (window.innerWidth < 768) {
        this.openDropdown =
          this.openDropdown === name
            ? null
            : name;
      }
    },
    /**
     * ============================================================
     * PC端鼠标移入下拉菜单
     * ============================================================
     */
    desktopHover(name) {
      if (window.innerWidth >= 768) {
        this.openDropdown = name;
      }
    },
    /**
     * ============================================================
     * 新闻搜索
     *
     * 统一跳转：
     *
     * /newsearch?keyword=关键词
     * ============================================================
     */
    searchNews() {
      const keyword =
        this.searchKeyword.trim();
      /**
       * 没有关键词
       */
      if (!keyword) {
        this.$router.push({
          path: '/newsearch'
        });
        this.closeMobileMenu();
        return;
      }
      /**
       * 有关键词
       */
      this.$router.push({
        path: '/newsearch',
        query: {
          keyword: keyword
        }
      });
      /**
       * 移动端关闭菜单
       */
      this.closeMobileMenu();
    },
    /**
     * ============================================================
     * 清空搜索
     * ============================================================
     */
    clearSearch() {
      /**
       * 清空输入框
       */
      this.searchKeyword = '';
      /**
       * 如果当前是新闻搜索页面
       *
       * /newsearch?keyword=xxx
       *
       * 变成：
       *
       * /newsearch
       */
      if (
        this.$route.path === '/newsearch'
      ) {
        this.$router.push({
          path: '/newsearch'
        });
        return;
      }
      /**
       * 如果当前是新闻相关页面
       */
      if (
        this.$route.path.startsWith('/news')
      ) {
        this.$router.push({
          path: this.$route.path
        });
      }
    }
  }
};
</script>
<style scoped src="@/assets/styles/top-nav.css"></style>